import React from 'react';
import './RadioTab.less';

export type TKey = string | number;

export interface IItem {
  name: React.ReactNode;
  key: TKey;
}

export interface IRadioTabProps {
  itemList: IItem[];
  className?: string;
  onChange?: (key: TKey) => void;
  size?: 'small' | 'normal';
  tabKey: TKey;
}
type Props = IRadioTabProps;

export function RadioTab(props: Readonly<Props>) {
  const { itemList, className = '', onChange, size, tabKey } = props;

  const changeTab = (key: TKey) => {
    onChange && onChange(key);
  };

  return (
    <div
      className={`common-presenter k-common-radio-tab ${className} ${
        size === 'small' ? 'small' : ''
      }`}
    >
      {itemList.map(item => (
        <div
          className={`tab__item ${tabKey === item.key ? 'act' : ''}`}
          key={item.key}
          onClick={eve => {
            eve.stopPropagation();
            changeTab(item.key);
          }}
        >
          {item.name}
        </div>
      ))}
    </div>
  );
}

export default RadioTab;
